export default {
  debug: {
    ErrorHandler: {
      verbose: false
    }
  }
}
